import React,{useState} from "react";
import { Button, Modal } from "react-bootstrap";

const CheckModal = ({
  show,
  handleClose,
  load=false,
  title,
  bodyText,
  checkText="delete",
  btnText,
  callback,
  callbackParameters=[],
}) => {

   const [input, setInput] = useState("");

   return(
    <>
       <Modal
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
          >
            <Modal.Header closeButton>
              <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {bodyText}
              <br />
              <br />
              <p>
              you must enter "<span style={{ color: "red" }}>{checkText}</span>" to
              proceed.
              </p>
              <input
                onChange={(e) => {
                  setInput(e.target.value);
                }}
              />
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose}>
                Close
              </Button>
                <Button
                  disabled={ load ? true : input.trim() === checkText ? false : true }
                  variant="danger"
                  onClick={() => {
                    callback([...callbackParameters]);
                    //you can call the handleClose function right after it or may be in the callback function
                    // handleClose();
                  }}
                >
                  {load ? 'Loading...' : btnText}
                </Button>
            </Modal.Footer>
        </Modal>
    </>
   )
}

export default CheckModal;